

exports.__esModule = true;
exports.$xoPayWithSelectionPageComponent = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _logger = require('xo-beaver/dist/logger');

var _index = require('js/lib/index');

var _integration = require('js/lib/integration');

var _squid = require('squid');

var _index2 = require('xo-device-info/dist/index');

var _auth = require('xo-models/src/auth');

var _user = require('xo-models/src/user');

var _app = require('xo-models/src/app');

var _checkout = require('xo-models/src/checkout');

var _thirdPartyInfo = require('xo-third-party-components/src/thirdParty-info');

var _util = require('pages/xo-login/util');

var _loginEligibility = require('pages/xo-login/loginEligibility');

var _factory = require('pages/xo-login/tokenized-wallet-loader/factory');

var _kmliUpsell = require('xo-login-components/src/onetouch-interstitial/kmliUpsell');

require('xo-page-components/src/value-props/directive');

require('xo-title/dist/directive');

require('xo-ui-components/src/card-loader/directive');

require('xo-ui-components/src/message/directive');

require('pages/xo-login/onboarding/directive');

require('xo-login-components/src/unified-login/directive');

require('xo-form-components/src/language-options/directive');

require('xo-login-components/src/login/handler/directive');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var $xoPayWithSelectionPageComponent = exports.$xoPayWithSelectionPageComponent = _squid.$Component.extend('$xoPayWithSelectionPageComponent', {
    tag: 'xo-pay-with-selection-page',
    template: _template2['default'],
    scope: {
        token: '=?'
    },
    link: function link() {
        _logger.$logger.info('login_link');
    },
    lifecycle: {
        enter: function enter() {
            (0, _jquery2['default'])('#contents').addClass('payWithSelection');
        },
        populate: function populate() {
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
                flowEligibility: _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                    params: {
                        geolocation: _squid.$meta.geolocation,
                        localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                        braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                        fundingSource: _squid.$util.param('fundingSource')
                    }
                })
            }).then(function () {
                var country = $scope.checkoutAppData.merchant.merchant_country;

                return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment', false, true).then(function (result) {
                    var treatmentName = result && result.treatment_name || '';

                    if (treatmentName) {
                        _logger.$logger.info('xo_hermesnode_hide_cart_logo_treatment');
                        (0, _jquery2['default'])('.cartContainer').hide();
                        (0, _jquery2['default'])('.merchantHeader > .headerWrapper').hide();
                    }
                });
            });
        },
        exit: function exit() {
            (0, _jquery2['default'])('#contents').removeClass('payWithSelection');
            var $scope = this;

            (0, _squid.$populate)($scope, {
                checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token)
            }).then(function () {
                var country = $scope.checkoutAppData.merchant.merchant_country;

                return (0, _squid.$pxp)('xo_hermesnode_config', { 'ctx.COUNTRY': country }, 'xo_hermesnode_hide_cart_logo_treatment', false, true).then(function (result) {
                    var treatmentName = result && result.treatment_name || '';
                    if (treatmentName) {
                        (0, _jquery2['default'])('.cartContainer').show();
                        (0, _jquery2['default'])('.merchantHeader > .headerWrapper').show();
                    }
                });
            });
        }
    },
    rootEvents: {
        allLoaded: function allLoaded() {
            if (!_integration.$integration.getConfig('ALLOW_AUTH')) {
                if (_integration.$integration.getConfig('CAN_FRAMEBUST')) {
                    if (window.xchild) {
                        var isWebView = window.paypal && window.paypal.isWebView && window.paypal.isWebView();

                        if (!isWebView) {
                            _uiRouter.$state.go('checkout.framebust', { action: 'open', url: window.location.href.split('#')[0] });
                        }
                    } else {
                        return _index.$miniBrowser.frameBust(this.props.token);
                    }
                } else {
                    throw _integration.$integration.error('Can not framebust');
                }
            }
        }
    },
    controller: ['$scope', function ($scope) {
        _logger.$logger.info('xoPayWithSelection_controller');
        $scope.ulEligibility = false;
        $scope.useTokenizationAnimation = false;
        var fptiHardErrors = ['RESTRICTED_USER', 'PAYEE_BLOCKED_TRANSACTION', 'PAYMENT_ALREADY_DONE', 'PAYMENT_DENIED', 'PAYEE_ACCOUNT_RESTRICTED', 'INVALID_RESOURCE_ID', 'EXPIRED_SESSION', 'PAYER_COUNTRY_NOT_ALLOWED', 'PAYER_LOGIN_COUNTRY_NOT_ALLOWED', 'GAMING_FUNDING_SOURCE_VALIDATION_FAILED'];

        /* If we detect a back/forward button click to land on the app, do not auto-login. In this case, the buyer
         is attempting to navigate to a specific page, so we should not auto-redirect them.
          This also fixes an issue with users:
         - Authorizing the checkout session
         - Redirecting to the merchant
         - Hitting back and landing on login page
         - Calling create on checkout and overwriting the authorization
         - Hitting forward and landing again on merchant page
         */
        if (window.performance && window.performance.navigation && window.performance.navigation.type === 2) {
            _angular.$rootScope.forceLogin = true;
        }

        if (!_angular.$rootScope.forceLogin) {
            $scope.autoLogin = true;
        }

        _angular.$rootScope.forceLogin = true;

        $scope.hideGuest = _uiRouter.$stateParams.targetPage === 'PAYER_AUTHENTICATION_REQUIRED' || _uiRouter.$stateParams.showNotYou;
        $scope.promptlogin = $scope.hideGuest && !(0, _squid.$feature)('riskyLoginContingency');

        // log statement for mobile webview
        if (_index2.$DeviceInfo.isApp()) {
            _logger.$logger.debug('HERMES_IN_MOBILE_WEBVIEW');
        }

        if (!_index.$miniBrowser.isMiniBrowser() && _squid.$locale.country === 'BR') {
            var brPxp = _squid.$config.pxpExperiments.BR.xo_br_hermesnode_login_design;

            (0, _squid.$pxpFactors)(brPxp.pgName, brPxp.params, brPxp.pattern, false, true).then(function (result) {
                $scope.loginDesignExp = result;
            });
        }

        var ROUTE_MAPPING = {
            ECONSENT_REQUIRED: 'checkout.econsent'
        };

        $scope.onContingency = function (name, contingency) {
            if (!ROUTE_MAPPING[name]) {
                throw new _squid.$FallbackError({
                    reason: name.toLowerCase(),
                    product: 'ux'
                });
            }
            _uiRouter.$state.go(ROUTE_MAPPING[name]);
        };

        $scope.checkoutSession = _checkout.$CheckoutSessionModel.instance(_angular.$rootScope.token);
        $scope.eConsent = _user.$EConsentModel.instance(_angular.$rootScope.token);
        $scope.tokenizedWalletEligibility = _app.$TokenizedWalletEligibilityModel.instance(_angular.$rootScope.token);
        $scope.dependencyEligibility = true;

        $scope.setBuyer = function () {
            var fptiData = {
                from: 'CREATE_XO_SESSION',
                to: 'process_create_xo_session'
            };

            function handleContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                fptiData.int_error_code = err.cause;
                fptiData.error_source = 'paymentapiplatformserv';
                fptiData.error_type = fptiHardErrors.indexOf(err.cause) > -1 ? 'hard_decline' : 'soft_decline';
                _logger.$logger.info('checkout_fpti', fptiData);
                throw err;
            }

            function handleNoValidTopupFiContingency(name, err) {
                // Check if negative case has been previously handled.
                if (!$scope.dependencyEligibility) {
                    return;
                }
                if ($scope.checkoutCart.isWalletTokenization()) {
                    $scope.checkoutSession.contingency = name;
                    _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                } else {
                    handleContingency(name, err);
                }
            }

            _logger.$logger.info('checkout_fpti', {
                from: 'CREATE_XO_SESSION',
                to: 'prepare_create_xo_session'
            });

            $scope.useTokenizationAnimation = $scope.checkoutCart.isWalletTokenization();
            var walletTokenization = $scope.checkoutCart.isWalletTokenization();

            if ($scope.useTokenizationAnimation) {
                _angular.$rootScope.$emit('allLoaded');

                $scope.setbuyerProgress = 'notStarted';
                _logger.$logger.info('tokenized_wallet', {
                    'from': 'adding_pp_ap_animation',
                    'to': 'prepare_adding_pp_ap_animation',
                    'context_id': _angular.$rootScope.token,
                    'context_type': 'EC-Token',
                    'billing_token': _squid.$meta.baToken
                });

                (0, _angular.$timeout)(function () {
                    $scope.setbuyerProgress = 'pending'; // sets animation state to 80%
                    _logger.$logger.info('tokenized_wallet', {
                        'from': 'adding_pp_ap_animation',
                        'to': 'process_adding_pp_ap_animation',
                        'context_id': _angular.$rootScope.token,
                        'context_type': 'EC-Token',
                        'billing_token': _squid.$meta.baToken
                    });
                }, 300);
            }

            $scope.eConsent.reload({
                batch: {
                    name: 'setbuyer',
                    silent: $scope.useTokenizationAnimation,
                    id: 'eConsent',
                    dependencies: []
                },
                contingencies: {
                    ECONSENT_REQUIRED: function ECONSENT_REQUIRED(name, err) {
                        if ($scope.dependencyEligibility) {
                            $scope.dependencyEligibility = false;
                            _logger.$logger.debug('ULLOGIN_ECONSENT_REQUIRED');
                            _uiRouter.$state.go('checkout.econsent');
                        }
                    }
                }
            });

            if (walletTokenization) {
                var params = {
                    wallet_brand: 'APAY',
                    tenant_id: 'Hermes'
                };
                if (_squid.$meta.query && _squid.$meta.query.wallet_id) {
                    params.wallet_id = _squid.$meta.query.wallet_id;
                }
                if (_squid.$meta.query && _squid.$meta.query.jwt) {
                    params.jwt = _squid.$meta.query.jwt;
                }

                $scope.tokenizedWalletEligibility.reload({
                    params: params,
                    batch: {
                        name: 'setbuyer',
                        id: 'tokenizedWalletLightEligibility',
                        silent: $scope.useTokenizationAnimation,
                        dependencies: ['eConsent']
                    },
                    success: function success(result) {
                        if (!result.eligible) {
                            var msg = 'tokenized_wallet_ineligible_for_provisioning';
                            _logger.$logger.info(msg);

                            if ($scope.dependencyEligibility) {
                                $scope.dependencyEligibility = false;
                                _uiRouter.$state.go('checkout.genericError', {
                                    code: 'ANDROID_PAY_ELIGIBILITY_ERROR'
                                });
                            }
                        }
                    }
                });
            }

            var isPayPalCredit = $scope.checkoutAppData.is_second_button_txn || _squid.$Class.get(window, 'xprops.fundingSource') === 'credit';

            $scope.checkoutSession.action('create', {
                data: {
                    baToken: $scope.checkoutCart.billing && $scope.checkoutCart.billing.ba_token,
                    preselected_fi_type: isPayPalCredit ? 'credit' : undefined
                },
                batch: {
                    name: 'setbuyer',
                    id: 'createCheckoutSession',
                    silent: $scope.useTokenizationAnimation,
                    dependencies: walletTokenization ? ['eConsent', 'tokenizedWalletLightEligibility'] : ['eConsent']
                },
                success: function success(result) {
                    fptiData.available_plan_count = $scope.checkoutSession.getPlanList() ? $scope.checkoutSession.getPlanList().length : '0';

                    _logger.$logger.info('checkout_fpti', fptiData);

                    if (!$scope.dependencyEligibility) {
                        return;
                    }

                    if ($scope.auth.password_less && $scope.checkoutCart.isBilling()) {
                        if ((0, _squid.$feature)('pomaPasswordRecovery')) {
                            _uiRouter.$state.go('checkout.createPassword', { targetPage: 'BILLING_AGREEMENTS' });
                        }
                        return;
                    }

                    if (isPayPalCredit) {
                        return _util.$capeRedirectUtil.handleCapeRouting(result, $scope.checkoutCart, _angular.$rootScope.token);
                    }

                    return _kmliUpsell.$KmliUpsell.eligible(_angular.$rootScope.token).then(function (isEligible) {
                        if (isEligible.eligible) {
                            var stateName = isEligible.type === 'member' ? 'KMLI_UPSELL' : 'KMLI_reactivation';

                            _logger.$logger.info('checkout_fpti', {
                                from: stateName,
                                to: 'prepare_kmli_upsell'
                            });

                            var path = _index2.$DeviceInfo.isMobile() ? 'checkout.FullpageOnetouchUpsell' : 'checkout.review.oneTouchUpsell';

                            return _uiRouter.$state.go(path, { oneTouchFlowName: 'checkout' });
                        }

                        if ($scope.auth.rtExchanged && (0, _squid.$feature)('rmSpinnerText')) {
                            $scope.checkoutSession.message = {
                                type: 'success',
                                msgKeys: ['login.loggedInWithOneTouch']
                            };
                        }

                        if ($scope.checkoutSession.negBals) {
                            return _uiRouter.$state.go('checkout.negativeBalanceRecovery');
                        }

                        if ($scope.checkoutCart.isWalletTokenization()) {
                            _factory.$TokenizedWalledLoaderFactory.goToTokenizationInfoPage();
                        } else {
                            _uiRouter.$state.go('checkout.review');
                        }
                    });
                },
                contingencies: {
                    // override contingency.js handler with custom logic to support both xoon/hermes flows
                    NEED_AUTHENTICATED_CARD: function NEED_AUTHENTICATED_CARD(name, err) {
                        // Check if negative case has been previously handled.
                        if (!$scope.dependencyEligibility) {
                            return;
                        }
                        // come from guest or have alternate FI options, go to review
                        if (_squid.$util.param('redirectToHermesOnUpopCancel') === 'xoon' || err && err.resolution && err.resolution.data && err.resolution.data.alternate_options) {
                            _uiRouter.$state.go('checkout.review');
                        } else {
                            // else go to addCard
                            _uiRouter.$state.go('checkout.updateCard.addCardFlow.addCard');
                        }
                    },
                    NEED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    EXPIRED_DEBIT_CARD: handleNoValidTopupFiContingency,
                    DEFAULT: handleContingency
                }
            });
        };

        // Sorry for the indirection here.  There's postAuth, so "preAuth" compliments it well (easier on the brain)
        $scope.preAuth = function () {
            // For UL, batch up eConsent, xoSession
            if ($scope.ulEligibility) {
                $scope.setBuyer();
            }
        };

        $scope.onSuccess = function () {
            _logger.$logger.info('checkout_fpti', {
                'from': 'CHOOSE_PAYMENT_METHOD',
                'to': 'process_continue_with_paypal'
            });

            // If the experiment is enabled, we already have what we need, so /quit.
            if ($scope.ulEligibility) {
                return;
            }

            $scope.setBuyer();
        };

        function fetchGuestButtonPxpVarients() {
            $scope.guestVariant = {};
            // PXP for showing Guest button Call-To-Actions
            return (0, _squid.$pxp)('xo_hermesnode_guest_cta', {
                'ctx.COUNTRY': _squid.$locale.country
            }, '(xo_hermesnode_guest_cta_)(.*)', false, true).then(function (result) {
                var treatmentName = result && result.treatment_name || '';

                switch (treatmentName) {
                    case 'xo_hermesnode_guest_cta_standard_label_treatment':
                        $scope.guestVariant.standardGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    case 'xo_hermesnode_guest_cta_card_icons_treatment':
                        $scope.guestVariant.cardIconsAboveGuestBtn = true;
                        $scope.guestVariant.test = true;
                        break;
                    default:
                    // Do nothing
                }
            });
        }

        (0, _squid.$populate)($scope, {
            flowEligibility: _checkout.$FlowEligibilityModel.instance(_angular.$rootScope.token).retrieve({
                params: {
                    geolocation: _squid.$meta.geolocation,
                    localeCountry: _squid.$locale.country, // We need this till we completely migrate to server side locale resolution
                    braintreeInegration: _squid.$util.param('bt_int_type') === '2' ? 'SFAuthSession' : '',
                    fundingSource: _squid.$util.param('fundingSource')
                }
            }),
            auth: _auth.$AuthModel.instance(),
            checkoutAppData: _checkout.$CheckoutAppDataModel.instance(_angular.$rootScope.token),
            checkoutCart: _checkout.$CheckoutCartModel.instance(_angular.$rootScope.token)
        }).then(function () {
            if ($scope.flowEligibility.guest) {
                return fetchGuestButtonPxpVarients();
            }
            (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCredit');
            (0, _jquery2['default'])('.paypalHeaderWrapper').removeClass('paypalCreditTnc');
        }).then(function () {
            $scope.expandPaypalDrawer = false;
            $scope.expandVenmoDrawer = false;
            $scope.expandBaiduDrawer = false;
            $scope.hideLoginHandlerTitle = true;

            $scope.clickPaypalDrawer = function () {
                $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;

                // if drawer expanded, we track it.
                if ($scope.expandPaypalDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_paypal_drawer'
                    });
                }

                // if Venmo is expanded, close it
                $scope.closeVenmoDrawer();
                $scope.closeBaiduDrawer();
                return $scope.expandPaypalDrawer;
            };

            $scope.clickVenmoDrawer = function () {
                $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;

                // if drawer expanded, we'll track it
                if ($scope.expandVenmoDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_venmo_drawer'
                    });
                }

                // if paypal is expanded, close it
                $scope.closePaypalDrawer();
                $scope.closeBaiduDrawer();
                return $scope.expandVenmoDrawer;
            };

            $scope.clickBaiduDrawer = function () {
                $scope.expandBaiduDrawer = !$scope.expandBaiduDrawer;

                if ($scope.expandBaiduDrawer) {
                    _logger.$logger.info('checkout_fpti', {
                        from: 'CHOOSE_PAYMENT_METHOD',
                        to: 'show_baidu_drawer'
                    });
                }

                // if other drawers expanded, close them
                $scope.closePaypalDrawer();
                $scope.closeVenmoDrawer();
                return $scope.expandBaiduDrawer;
            };

            $scope.closePaypalDrawer = function () {
                // if paypal is expanded, close it
                if ($scope.expandPaypalDrawer) {
                    $scope.expandPaypalDrawer = !$scope.expandPaypalDrawer;
                }
            };

            $scope.closeVenmoDrawer = function () {
                // if Venmo is expanded, close it
                if ($scope.expandVenmoDrawer) {
                    $scope.expandVenmoDrawer = !$scope.expandVenmoDrawer;
                }
            };

            $scope.closeBaiduDrawer = function () {
                // if other drawers expanded, close them
                if ($scope.expandBaiduDrawer) {
                    $scope.expandBaiduDrawer = !$scope.expandBaiduDrawer;
                }
            };

            $scope.displayBaiduDrawer = $scope.flowEligibility.baiduWallet;
            $scope.displayVenmoDrawer = $scope.flowEligibility.venmo;

            $scope.sendToVenmo = function () {
                window.location.href = _thirdPartyInfo.thirdPartyInfo.buildVenmoURL();
            };

            $scope.proceedWithBaidu = function () {
                // if incontext, we'll resize and center to allow for the minimum size of the Baidu flow.
                if (window.xprops) {
                    var xPos = window.screen.width / 2 - 800 / 2;
                    var yPos = window.screen.height / 2 - 800 / 2;
                    window.resizeTo(800, 800);
                    window.moveTo(xPos, yPos);
                }
                _uiRouter.$state.go('checkout.thirdPartyWalletFlow');
            };

            if ($scope.displayBaiduDrawer && $scope.displayVenmoDrawer) {
                (0, _angular.$timeout)($scope.clickBaiduDrawer, 800);
            } else if ($scope.displayVenmoDrawer) {
                (0, _angular.$timeout)($scope.clickVenmoDrawer, 800);
            } else {
                (0, _angular.$timeout)($scope.clickBaiduDrawer, 800);
            }

            return (0, _loginEligibility.$loginEligibility)(_angular.$rootScope.token, !$scope.autoLogin).then(function (result) {
                if (result === 'unifiedLogin') {
                    $scope.ulEligibility = true;
                } else if (result === 'apsIntegration') {
                    $scope.apsIntegration = 'apsIntegration';
                } else if (result === 'apsIntegrationRM') {
                    $scope.apsIntegration = 'apsIntegrationRM';
                }
            }).then(function () {
                var reinitDisplay = function reinitDisplay() {
                    $scope.promptlogin = false;
                    $scope.hideGuest = false;
                    $scope.autoLogin = true;
                    delete _uiRouter.$stateParams.targetPage;
                    delete _uiRouter.$stateParams.showNotYou;
                };

                $scope.logout = $scope.promptlogin ? function () {
                    _logger.$logger.info('not_you_logout');
                    _logger.$logger.info('checkout_fpti', {
                        from: 'LOGIN_UL',
                        to: 'login_with_diff_user'
                    });
                    $scope.auth.logout().then(function () {
                        $scope.auth.reload().then(function () {
                            reinitDisplay();
                            $scope.reload();
                        });
                    });
                } : function () {
                    _logger.$logger.info('logout_switch_display');
                    reinitDisplay();
                };
            });
        });
    }]
});

angular.value("$xoPayWithSelectionPageComponent", $xoPayWithSelectionPageComponent);
_angular.$rootScope;

_angular.$timeout;

_uiRouter.$state;

_uiRouter.$stateParams;

_logger.$logger;

_index.$miniBrowser;

_integration.$integration;

_squid.$pxp;

_squid.$util;

_squid.$meta;

_squid.$Class;

_squid.$locale;

_squid.$config;

_squid.$feature;

_squid.$populate;

_squid.$Component;

_squid.$pxpFactors;

_squid.$FallbackError;

_index2.$DeviceInfo;

_auth.$AuthModel;

_user.$EConsentModel;

_app.$TokenizedWalletEligibilityModel;

_checkout.$CheckoutCartModel;

_checkout.$CheckoutAppDataModel;

_checkout.$CheckoutSessionModel;

_checkout.$FlowEligibilityModel;

_thirdPartyInfo.thirdPartyInfo;

_util.$capeRedirectUtil;

_loginEligibility.$loginEligibility;

_factory.$TokenizedWalledLoaderFactory;

_kmliUpsell.$KmliUpsell;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-pay-with-selection/directive.js
// module id = ./pages/xo-pay-with-selection/directive.js
// module chunks = 0